<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加体检记录</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                  <el-row>
                      <el-col :span="12" class="item">
                          <el-form-item label="体检机构" required prop="organizationName">
                              <el-input v-model="addForm.organizationName" placeholder="请输入体检机构"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="体检时间" required prop="inspectTime">
                              <el-date-picker
                                  v-model="addForm.inspectTime"
                                  type="date"
                                  placeholder="选择日期"
                                  value-format="yyyy-MM-dd"
                                  style="width:100%">
                              </el-date-picker>
                          </el-form-item>
                      </el-col>

<!--                    <el-col :span="24" class="item">-->
<!--                      <div>体检图片</div>-->
<!--                      <el-upload-->
<!--                          action=""-->
<!--                          :limit="limitCountStart"-->
<!--                          :before-upload="beforeUploadStart"-->
<!--                          :on-preview="handlePictureCardPreviewStart"-->
<!--                          :on-change="handleChangeStart"-->
<!--                          :on-success="imgSuccessStart"-->
<!--                          :http-request="uploadHttpStart"-->
<!--                          list-type="picture-card"-->
<!--                          :on-remove="handleRemoveStart"-->
<!--                          :class="{disabled:uploadDisabledStart}"-->
<!--                          :file-list="fileListStart">-->
<!--                        <i slot="default" class="el-icon-plus"></i>-->
<!--                      </el-upload>-->
<!--                      <el-dialog :modal-append-to-body="false" :visible.sync="imgVisibleStart" width="30%">-->
<!--                        <img width="100%" :src="dialogImageUrlStart" alt="图片未找到"/>-->
<!--                      </el-dialog>-->
<!--                    </el-col>-->

                      <el-col :span="24" class="item">
                          <el-form-item label="备注" >
                              <el-input
                              type="textarea"
                              :autosize="{ minRows: 3, maxRows: 6}"
                              placeholder="请输入"
                              v-model="addForm.details">
                              </el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'myExaminationRecordsAdd',
        data() {
            return {
                loading: false,
                iconDialog: false,
                elderlyName:'',

                addForm:{
                    timeStr:timeStr,
                    staffCode:getStaffCode(),
                    sign:'',
                    organizationName:'',
                    elderlyCode:'',
                    doctorName:'',
                    inspectItem:'',
                    details:'',
                    inspectTime:'',

                  arr:[],

                },

              limitCountStart: 3,
              uploadDisabledStart: false,
              //是否显示预览图片
              imgVisibleStart: false,
              //预览图片url
              dialogImageUrlStart: "",
              fileListStart: [],
              headImgArrStart:[],


              rules:{
                    organizationName:[
                        { required: true, message: '请输入体检的组织', trigger: 'blur' },
                    ],
                    doctorName:[
                        { required: true, message: '请输入医生姓名', trigger: 'blur' },
                    ],
                    inspectItem:[
                        { required: true, message: '请输入体检项目', trigger: 'blur' },
                    ],

                    inspectTime:[
                        { required: true, message: '请选择体检时间', trigger: 'blur' },
                    ],

                },

            }
        },

        methods: {


          // 图片上传成功 不执行
          imgSuccessStart(response, file, fileList) {
            this.uploadDisabledStart = fileList.length >= this.limitCountStart;
          },

          // 预览图片
          handlePictureCardPreviewStart(file) {
            this.imgVisibleStart = true;
            this.dialogImageUrlStart = file.url;
          },
          // 删除图片
          handleRemoveStart(file, fileList) {
            this.uploadDisabledStart = fileList.length >= this.limitCountStart;

            //console.log(file);
            //console.log(fileList);

            let Pics = this.headImgArrStart;
            Pics.forEach((item, index) => {
              if (file.url == item.url) {
                Pics.splice(index, 1);
              }
            })

            let Pics2 = this.fileListStart;
            Pics2.forEach((item, index) => {
              if (file.url == item.url) {
                Pics2.splice(index, 1);
              }
            })


          },

          //图片更改
          handleChangeStart(file,fileList) {
            this.uploadDisabledStart = fileList.length >= this.limitCountStart;
          },

          beforeUploadStart(){

          },
          uploadHttpStart(file) {

            let fd = new FormData();
            fd.append('file',file.file);
            fd.append('staffCode',getStaffCode());
            fd.append('timeStr',timeStr);
            fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));


            let that = this;
            that.fileListStart.push({uid:file.file.uid,name:file.file.name,url:''});


            this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
              //console.log(res);

              if(res.data.error == 0){

                that.headImgArrStart.push({ url: res.data.data.path,uid:file.file.uid  });

                for(let i=0;i<that.fileListStart.length;i++){
                  if(that.fileListStart[i].uid == file.file.uid){
                    that.fileListStart[i].url = that.$imgUrl+ res.data.data.path;
                  }
                }

              }
              else if(res.data.error == 1){

                let Pics = that.fileListStart;
                Pics.forEach((item, index) => {
                  if (file.file.uid == item.uid) {
                    Pics.splice(index, 1);
                  }
                })

              }

              that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;

            }).catch(error => {
              console.log(error);

              let Pics = that.fileListStart;
              Pics.forEach((item, index) => {
                if (file.file.uid == item.uid) {
                  Pics.splice(index, 1);
                }
              })

              that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;

            })


          },



            init(elderlyCode,elderlyName){
                this.$refs.addForm.resetFields();
                this.addForm.elderlyCode=elderlyCode;
                this.elderlyName = elderlyName;

              this.fileListStart = [];
              this.headImgArrStart = [];
              this.uploadDisabledStart=false;
              this.addForm.arr = [];

            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

              this.loading = true;
              this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

              for(let i=0;i<this.headImgArrStart.length;i++){

                let url = this.headImgArrStart[i].url;
                url = url.replace(this.$imgUrl,"");

                this.addForm.arr.push(url);
              }


                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"EInspectRecord/Add",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("resultSuccess");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })

            },


        }
    }


</script>

<style lang="scss" scoped>

</style>
